export const CONTINUOUS_REVIEW_TYPES = {
  DATE_OF_JOINING: 'DATE_OF_JOINING',
  WORK_ANNIVERSARY: 'WORK_ANNIVERSARY',
  PROBATION_30_60_90: 'PROBATION_30_60_90',
  PIP: 'PIP',
};

export const REVIEW_PRESET_TYPES = {
  ANNUAL_APPRAISAL: 'ANNUAL_APPRAISAL',
  QUARTERLY_REVIEW: 'QUARTERLY_REVIEW',
  PIP_REVIEW: 'PIP_REVIEW',
  // COMPETENCY_ASSESSMENT: 'COMPETENCY_ASSESSMENT',
  CUSTOM: 'CUSTOM',

  // partial demo preset, it is existing working preset type, but shown a little differently when checkEnabledSimplifiedReviewDemoPresets flag is ON
  PROBATION_REVIEW: 'PROBATION_REVIEW',
  // demo preset types
  WORK_ANNIVERSARY_REVIEW: 'WORK_ANNIVERSARY_REVIEW',
  PROBATION_30_60_90: 'PROBATION_30_60_90',
};

export const REVIEW_CREATION_TYPES = {
  DEFAULT: 'DEFAULT',
  TRIGGERED: 'TRIGGERED',
};

export const REVIEW_TYPE_OPTIONS = [
  { label: 'One time', value: REVIEW_CREATION_TYPES.DEFAULT },
  { label: 'Continuous', value: REVIEW_CREATION_TYPES.TRIGGERED },
];
